import axios from "axios"
import urlJoin from 'url-join'

const rootUrl = 'https://api.wanikani.com'
const apiVersion = 'v2'

export const getItems = async (params) => {
  const { apiKey, resourceType, requestParams } = params
  const axiosConfig = {
    headers: {
      Authorization: `Bearer ${apiKey}`,
      "Wanikani-Revision": "20170710"
    },
  }
  try {
    const response = await axios.get(
      urlJoin(rootUrl, apiVersion, resourceType),
      {
        ...axiosConfig,
         params: requestParams
      }
    )

    return response.data
  } catch (error) {
    throw new Error(error)
  }
}
